<template>
    <div class="app-header media">
        <AppLogo :app="app" class="d-flex align-self-center mr-3"/>
        <div class="media-body align-self-center font-18">
            {{ app.name }}
        </div>
    </div>
</template>

<script>
import AppLogo from './AppLogo'

export default {
    name: 'AppLogoWithName',
    components: {AppLogo},
    props: {
        app: {
            type: Object,
            required: true
        }
    }
}
</script>
